var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9939 5.59991V5.57009C15.9939 2.8827 14.3651 1.2998 11.6087 1.2998H4.38595C1.62882 1.2998 0 2.8827 0 5.57009V11.4233C0 14.1107 1.62882 15.6998 4.38595 15.6998H11.6115C14.3679 15.6998 15.9967 14.1107 15.9967 11.4233V11.1785H12.6068C11.0271 11.1764 9.74877 9.92566 9.7509 8.38506C9.75374 6.84792 11.0306 5.60268 12.6068 5.59991H15.9939Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7968 5.59384H8.30788H8.31073H8.31642C8.65412 5.59245 8.92714 5.32413 8.92571 4.9941C8.92429 4.66476 8.64844 4.39852 8.31073 4.39991H3.7968C3.46123 4.40129 3.18893 4.66684 3.18751 4.99479C3.18608 5.32413 3.45909 5.59245 3.7968 5.59384ZM11.233 8.73752C11.4003 9.49846 12.0673 10.0338 12.8289 10.0199H15.4283C15.7451 10.0199 16.0021 9.75745 16.0021 9.43302V7.40778C16.0015 7.08404 15.7451 6.82088 15.4283 6.82018H12.7677C11.9014 6.82297 11.2018 7.54214 11.2031 8.42841C11.2031 8.53214 11.2133 8.63587 11.233 8.73752ZM13.5997 8.42021C13.5997 8.86204 13.2416 9.22021 12.7998 9.22021C12.3581 9.22021 12 8.86204 12 8.42021C12 7.97839 12.3581 7.62022 12.7998 7.62022C13.2416 7.62022 13.5997 7.97839 13.5997 8.42021Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.741679b6307c684cc1dc5582519a89fa.svg";
export { ForwardRef as ReactComponent };